import React from 'react';
import styled from "styled-components";

const StyledSvg = styled.svg`
  width: 1rem;
  fill: #fff;
  margin-left: 1rem;
  transition: all ease 0.25s;
`;
const StyledButton = styled.button`
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  padding: 0 2rem;
  border-radius: 2rem;
  text-decoration: none;
  text-align: center;
  min-width: 10rem;
  outline: 0;
  cursor: pointer;
  transition: all ease 0.25s;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #fff;
  background: #635BFF;
  border: 1px solid #635BFF;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

  :hover {
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    background: #4F48CC;
    color: #fff;
    border-color: #4F48CC;
    
    ${StyledSvg} {
      transform: translateX(0.5rem);
    }
  }
`;

const PrimaryButton = ({buttonText = ''}) => {
  return <StyledButton>
    {buttonText}
    <StyledSvg xmlns="http://www.w3.org/2000/svg"
               x="0"
               y="0"
               enableBackground="new 0 0 850 500"
               viewBox="0 0 850 500"
    >
      <path
        d="M484.14 226.886L306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z"></path>
    </StyledSvg>
  </StyledButton>;
};

export default PrimaryButton;